import { createRouteRef } from '@backstage/core-plugin-api';

export const adminRouteRef = createRouteRef({
  id: 'tech-radar:admin',
});
export const homeRouteRef = createRouteRef({
  id: 'tech-radar:home',
});
